import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import { SideBarGetter, SideBarState } from "@/components/sidebar/types";

export const getters: GetterTree<SideBarState, RootState> &
  Record<SideBarGetter, Getter<SideBarState, RootState>> = {
  [SideBarGetter.GetSideBarOpen](state) {
    return state.sideBarOpen;
  },
  [SideBarGetter.GetAppMenuItems](state) {
    return state.appMenuItems;
  }
};
